// File: @/app/error.tsx

'use client';

import { c as _c } from "react/compiler-runtime";
import { type JSX, useEffect } from 'react';
import { TrackedButton } from '@/components/analytics/tracked-button';
import { StatusMessage } from '@/components/content/status-message';
import { clientErrorEvent, track } from '@/lib/analytics';
import { logger } from '@/lib/logger';
interface ErrorPageProps {
  readonly error: Error & {
    readonly digest?: string;
  };
  readonly reset: () => void;
}

/**
 * Route-level error boundary.
 *
 * Shows visitors a fixed, friendly message — never `error.message`, which
 * can expose internals. The real error goes to the logger and to Vercel
 * Analytics (`client-error`) for diagnosis.
 */
export default function ErrorPage(t0) {
  const $ = _c(5);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      logger.error("[Error Boundary] Application error", error, {
        digest: error.digest
      });
      track(clientErrorEvent(error.name, error.message));
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== reset) {
    t3 = <StatusMessage message={"Sorry \u2014 this page didn\u2019t load properly. Please try again."} title="Something went wrong"><TrackedButton className="rectangular-button-link" elementId="error-page-try-again" elementText="Try again" placement="app_error" onClick={reset}>Try again</TrackedButton></StatusMessage>;
    $[3] = reset;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}